import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import isLoggedIn from '../../utils/index.js';

export default class HomeConnect extends Component {
  constructor(props) {
    super(props);
  }

  handleSignUpClick = (e) => {
    e.preventDefault();
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
    this.props.openSignupFormRequest();
  }

  render() {
    const { user } = this.props.user;

    let joinSection = <div className="home-connectCopyWrapper">
      <div className="home-connectButtons">
        <div className="home-connectButtons-inner-wrapper">
          <button onClick={this.handleSignUpClick.bind(this)}
            className="home-connectButton"> Sign up (it's free)</button>
        </div>
      </div>

      <p className="home-connectDescription">
      Join WorldWideWomen members in 112 countries to receive previews of new resources, inspiring stories, invitations to local events &amp; more!
      </p>
    </div>






    if(isLoggedIn(user)) {
      joinSection = '';
    }

    return (
      <div className="home-connectOuterWrapper">
        <div className="home-mobileHairLine"><img src="images/1px_shim.png" /></div>
        <div>
        <div className="home-connectTop"><h3 className="home-connectTitle">Become a Member</h3></div>
          <div className="section-description">Join WorldWideWomen members to enjoy member-only benefits</div>
        </div>
        <section className="home-connect">
          


          <div className="home-connectLeftCol">
            <img src="images/home/connect_map4.png" />
          </div>

          <div className="home-connectRightCol">

            {/* BEGIN: JOIN CTA */}
              {joinSection}
            {/* END: JOIN CTA */}


            {/* BEGIN: RECOMMEND CTA */}
            <div className="home-connectCopyWrapper">

              <div className="home-connectButtons">
                <div className="home-connectButtons-inner-wrapper">
                  <Link className="home-connectButton home-applyToList" to="/apply-to-list-lp">Apply to list</Link>
                </div>
              </div>

              <p className="home-connectDescription">
              Apply to become an official WorldWideWomen Member Organization and tap into a powerful global community of women!
              </p>

            </div>
            {/* END: RECOMMEND CTA */}
          </div>

        </section>
        <div className="home-mobileHairLine"><img src="images/1px_shim.png" /></div>
      </div>

    );
  }
};



// WEBPACK FOOTER //
// ./src/components/home/HomeConnect.jsx